import { useCurrency } from '@/lib/entities/currency';
import { IOwnProjects } from '@/lib/entities/page';

import { Button } from '@/lib/shared/components/Buttons';
import { H2, P3 } from '@/lib/shared/components/Typography';
import { ArrowIcon } from '@/lib/shared/icons';
import { staticResource } from '@/lib/shared/utils/resources';
import { toMoney } from '@/lib/shared/utils/to-money';

import { clsx } from 'clsx';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import Link from 'next/link';

import css from './OfferCard.module.scss';

interface IProps {
  ownProject: IOwnProjects;
  index: number;
  length: number;
  theme?: 'light' | 'dark';
  onClick: () => void;
}

export const OfferCard = ({
  ownProject,
  index,
  length,
  theme = 'light',
  onClick,
}: IProps) => {
  const { t } = useTranslation('index');
  const {
    currency: { symbol: cur, value },
  } = useCurrency();

  const money = toMoney(ownProject.price[value]);

  return (
    <div
      className={clsx(css.offerCard, css[`offerCard--${theme}`])}
      onClick={onClick}
    >
      <div className={css.offerCardImgWrapper}>
        <Image
          sizes="(max-width: 996px) 405px, (max-width: 1200px) 532px, 33vw"
          src={
            staticResource(ownProject.image) || '/images/placeholder_image.webp'
          }
          alt={''}
          fill
        />
      </div>

      <div className={css.descriptionWrapper}>
        <div className={css.descriptionTop}>
          <p className={css.infoText}>
            0{index + 1}/
            <span className={css.infoText__disabled}>0{length}</span>
            <span className={'ml-2'} />|<span className={'ml-2'} />
            {ownProject.type || 'Villa'}
            <span className={'ml-2'} />|<span className={'ml-2'} />
            {ownProject.location || 'Phuket'}
          </p>

          <H2 className={css.h2Subtitle}>{ownProject.name}</H2>

          <P3 className={css.article}>{ownProject.description}</P3>
        </div>

        <div className={css.descriptionDown}>
          <H2 className={css.h2Subtitle}>
            {t('prepositions.from') || ''} {cur}
            {money}
          </H2>
          <div className={css.buttonWrapper}>
            <Button
              label={t('learnMoreAbout') || ''}
              theme={theme === 'light' ? 'light' : 'dark-invert'}
              size={'md'}
              as={Link}
              href={ownProject.url}
              icon={<ArrowIcon isRight />}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfferCard;
